import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PartnerService } from '../../partner.service';
import { BaseComponent } from 'src/app/shared/components/base-component/base.component';
import { StatisticsPlot, StatisticsTable } from '@shared/modules/statistics/statistics.model';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { PageWithSidebarComponent } from '@shared/modules/details-commons/components/page-with-sidebar/page-with-sidebar.component';
import { PartnerDetailsComponent } from '../partner-details/partner-details.component';

import { StatisticsComponent } from '@shared/modules/statistics/components/statistics/statistics.component';

@Component({
  templateUrl: './partner-details-page.component.html',
  imports: [PageWithSidebarComponent, PartnerDetailsComponent, StatisticsComponent]
})
export class PartnerDetailsPageComponent extends BaseComponent {
  private readonly partnerService = inject(PartnerService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly wsHelperService = inject(WsHelperService);

  private _partnerId: number;

  statisticsTable: StatisticsTable;
  statisticsPlots: StatisticsPlot;

  constructor() {
    const route = inject(ActivatedRoute);

    super();
    this.subSink.sink = route.params.subscribe(params => (this.partnerId = params.id));
  }

  get partnerId(): number {
    return this._partnerId;
  }

  set partnerId(id: number) {
    if (this._partnerId !== id) {
      this._partnerId = id;
      this.loadStatistics(id);
      this.loadStatisticsPlots(id);
    }
  }

  loadStatistics(partnerId: number): void {
    this.wsHelperService.callWithSpinner(this.partnerService.getPartnerStatistics(partnerId)).subscribe(stats => {
      this.statisticsTable = stats;
      this.changeDetectorRef.markForCheck();
    });
  }

  loadStatisticsPlots(partnerId: number): void {
    this.wsHelperService.callWithSpinner(this.partnerService.getPartnerStatisticsPlot(partnerId)).subscribe(statisticsPlots => {
      this.statisticsPlots = statisticsPlots;
      this.changeDetectorRef.markForCheck();
    });
  }
}
